import React, { useState, useEffect, useRef } from 'react';
import Button from "../../../../button/button";
import InputAnimated from "../../../../inputAnimated/inputAnimated";
import InputDate from "../../../../inputDate/inputDate";
import Select from "../../../../select/select";
import Tooltip from "../../../../Tooltip/Tooltip";
import CloseSVG from "../../../../icons/close";
import EditSVG from "../../../../icons/edit";
import './StudentSection.scss';
import PaymentHistory from "../PaymentHistory/PaymentHistory";
import { useNavigate } from "react-router-dom";
import Axios from 'axios'
import PasswordAlert from '../../../../passwordAlert/passwordAlert';
import InputAutoComplete from '../../../../autocomplete/autocomplete';
import { PostReceptionistInCharge } from '../../../../../utils/Apis/apis';
import { formatToLocalDate, getLocalDateObject } from '../../../../../utils/dateTimeZone';
import { GetInfoReceiptToRefund, PatchCancelReceipt, PatchUpdateObservationByStudent } from '../../../../../utils/Apis/receptionApis';
import RePrintReceipt from '../PaymentConfirm/RePrintReceipt/RePrintReceipt';
import { GetAllPaymentInfoByStudent } from '../../../../../utils/Apis/receptionApis';
import ConfirmModal from '../../../../ConfirmModalV3/confirmModal';
import LoadingComponent from '../../../../loading/LoadingComponent/loadingComponent';
import ChangeReceiptPaymentMethod from '../ChangeReceiptPaymentMethod/changeReceiptPaymentMethod';
import PaymentRefund from '../PaymentConfirm/paymentRefunds/paymentRefund';
import { dataDecrypt } from '../../../../../utils/dataDecrypt';
import { dataEncrpt } from '../../../../../utils/dataEncrypt';
import { isWeekInRanges } from '../../../../../utils/receptionUtils/payment';
const StudentSection = ({ studentsList = [], student, setStudents, removeStudentSection, index, books, amountInscription, showAlert, exemptWeeks, usr, exchange, levelUnitList, paymentStudentData, setPaymentStudentData }) => {
    // const [loading, setLoading] = useState(false);
    // const [error, setError] = useState(null);
    // const navigate = useNavigate();
    //ALERT
    const [showInscription, setShowInscription] = useState(false)
    const [inscriptionValue, setInscriptionValue] = useState('');
    const [paymentPlan, setPaymentPlan] = useState({})
    const [scholarShip, setScholarShip] = useState({})
    const [studentPay, setStudentPay] = useState(0)
    const [studentPaymentHistory, setStudentPaymentHistory] = useState([])
    const [inscriptionDate, setInscriptionDate] = useState('')
    const [buttonsState, setButtonState] = useState({
        disabled_inscription: false
    })
    const [disableTuition, setDisabledTuition] = useState(true)
    const [disableInscriptionInput, setDisabledInscriptionInput] = useState(true)
    const [isStudentClassOnline, setIsStudentClassOnline] = useState(false)
    const appliedPromoIdsRef = useRef(new Set());
    const [observation, setObservation] = useState('');
    const [studentId, setStudentId] = useState('')
    const [fullClassName, setFullClassName] = useState('')

    const [isOpenPrintReceipt, setIsOpenPrintReceipt] = useState(false)
    const [receiptResultData, setReceiptResultData] = useState({})
    const [paymentPIsOnline, setPaymentPIsOnline] = useState(false)
    const [specialDates, setSpecialDate] = useState({})
    const [weeksRemaining, setWeeksRemaining] = useState(null)
    /////////
    //Modal confirm for cancel and refund
    const [isOpenConfirmRefundCancelReceipt, setIsOpenConfirmRefundCancelReceipt] = useState(false);
    const [confirmConfig, setConfirmConfig] = useState({
        title: '',
        message: '',
        onAccept: null,
    });
    const [pendingAction, setPendingAction] = useState(null);
    const [dataChangePaymentMethod, setDataChangePaymentMethod] = useState(null)
    //
    const [loading, setLoading] = useState(false);

    const [refreshPaymentHistorySt, setRefreshPaymentHistorySt] = useState(false)
    //Modal
    // Define el estado para los handlers del modal
    const [modalHandlers, setModalHandlers] = useState({
        handleAcceptPassword: () => { },
        handleCancelPassword: () => { },
    });
    const [isPasswordRequired, setIsPasswordRequired] = useState(false);

    const [isOpenChangePaymentMethodModal, setIsOpenChangePaymentMethodModal] = useState(false)
    const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
    const [receiptDataToRefund, setReceiptDataToRefund] = useState(null)
    const [studentLevel, setStudentLevel] = useState(null)

    const hasAutoSelected = useRef(false);
    // Handle student selection and update payment history
    const handleStudentChange = async (selectedStudentId) => {
        if (!selectedStudentId) {
            // Si no hay selección (es decir, si el valor es null o undefined), puedes manejarlo aquí
            console.log("No student selected.");
            return; // Sale de la función sin hacer nada
        }

        const selectedStudent = studentsList.find(s => s.id === parseInt(selectedStudentId.id));
        if (!selectedStudent) {
            return; // Si no se encuentra el estudiante, sale de la función
        }
        setFullClassName(`${selectedStudent?.class_info?.full_day_class_name} / Modalidad: ${selectedStudent.class_info?.is_online ? 'Online' : 'Presencial'}` || '')
        setStudentId(selectedStudent.id)
        setIsStudentClassOnline(selectedStudent.class_info.is_online)
        setStudentLevel(selectedStudent?.class_info?.level || null)
        setObservation(selectedStudent.observation)
        // Mantiene las propiedades del estudiante antes de obtener el historial de pagos
        setStudents(prevStudents => {
            const updatedStudents = [...prevStudents];
            updatedStudents[index] = {
                ...updatedStudents[index],
                id_student: selectedStudent.id,
                name: selectedStudent.name,
                schoolarship: {},
                concepts_to_pay: {
                    tuition: [],
                    books: [],
                    inscription: {}
                },
                id_class: selectedStudent.class_info.id || '',
                inscription_date: selectedStudent.inscription_date,
                class_type: selectedStudent.class_info?.class_type || '',
                class_days: selectedStudent.class_info?.days || '',
                full_class_name: selectedStudent.class_info?.full_day_class_name || '',
                is_online: selectedStudent.class_info?.is_online || false,
                have_to_pay_enroll: selectedStudent.have_to_pay_enroll,
            };
            return updatedStudents;
        });
        if (showInscription) {
            toggleInscription()
        }

        try {
            setLoading(true)
            const studentPaymentInfoResponse = await GetAllPaymentInfoByStudent(selectedStudent.id);
            if (studentPaymentInfoResponse.status === 200) {
                const history = await paymentHistoryFormat(studentPaymentInfoResponse.response.receipt);
                setPaymentPlan(studentPaymentInfoResponse.response.payment_plan)
                const isOnline = studentPaymentInfoResponse.response.payment_plan.is_online === 1;
                setPaymentPIsOnline(isOnline);
                setScholarShip(studentPaymentInfoResponse.response.scholarship)
                setStudents(prevStudents => {
                    const updatedStudents = [...prevStudents];
                    updatedStudents[index] = {
                        ...updatedStudents[index],
                        paymentHistory: history, // Agrega el historial de pagos
                        schoolarship: studentPaymentInfoResponse.response.scholarship,
                        inactive_weeks: studentPaymentInfoResponse.response.inactive_weeks,
                        paused_weeks: studentPaymentInfoResponse.response.paused_weeks,
                    };
                    return updatedStudents;
                });
                const objectSepecialDates = await handleFormatSpecialDates(studentPaymentInfoResponse.response.inactive_weeks, studentPaymentInfoResponse.response.paused_weeks)

                setSpecialDate(objectSepecialDates)
                setLoading(false)
            } else if (studentPaymentInfoResponse.status === 201) {
                setLoading(false)
                setStudents(prevStudents => {
                    const updatedStudents = [...prevStudents];
                    updatedStudents[index] = {
                        ...updatedStudents[index],
                        paymentHistory: [], // Asegurar que el historial quede vacío
                    };
                    return updatedStudents;
                });
            }
        } catch (error) {
            console.error("Error obteniendo historial de pagos:", error);
        }
    };

    useEffect(() => {

        if (hasAutoSelected.current) return;

        if (!paymentStudentData?.studentId) return;

        if (studentsList.length === 0) return;

        const foundedStudent = studentsList.find(
            student => student.id === paymentStudentData.studentId
        );

        if (foundedStudent) {

            hasAutoSelected.current = true;

            handleStudentChange(foundedStudent);
            setPaymentStudentData(null);

        }

    }, [studentsList, paymentStudentData]);
    const calculateRemainingWeeks = (allLevels, studentLevel) => {
        // 1. Unificar todas las listas dinámicamente
        const mergedLevels = Object.values(allLevels).flat();

        // 2. Buscar el nivel del alumno
        const level = mergedLevels.find(l => l.label === studentLevel.name);
        if (!level) return null;

        // 3. Sacar número de unidad
        const unitNumber = parseInt(studentLevel.unit_name.match(/\d+/)?.[0]);
        if (!unitNumber) return null;

        // 4. Calcular semanas restantes
        return level.units - unitNumber;
    };
    useEffect(() => {
        if (studentLevel) {
            const weeks = calculateRemainingWeeks(levelUnitList, studentLevel);
            setWeeksRemaining(weeks)
        } else {
            setWeeksRemaining(null)
        }

    }, [studentLevel])

    const expandRange = (start, end) => {
        const [startWeek, startYear] = start.split('-').map(Number);
        const [endWeek, endYear] = end.split('-').map(Number);

        const result = [];

        let week = startWeek;
        let year = startYear;

        while (year < endYear || (year === endYear && week <= endWeek)) {
            result.push({
                week: String(week),
                year: String(year)
            });

            week++;

            if (week > 52) {
                week = 1;
                year++;
            }
        }

        return result;
    };
    const normalizeWeeks = (weeks) => {
        const map = new Map();

        weeks.forEach(w => {
            const key = `${w.year}-${w.week}`;
            map.set(key, w); // 🔥 elimina duplicados automáticamente
        });

        return Array.from(map.values()).sort((a, b) => {
            if (a.year !== b.year) return a.year - b.year;
            return a.week - b.week;
        });
    };

    const handleFormatSpecialDates = (inactive = [], paused = []) => {

        const safeInactive = Array.isArray(inactive) ? inactive : [];
        const safePaused = Array.isArray(paused) ? paused : [];

        const combined = [...safeInactive, ...safePaused];

        // 🔥 expandir
        const expanded = combined.flatMap(r =>
            expandRange(
                r.range_week_number.start,
                r.range_week_number.end
            )
        );

        // 🔥 limpiar + ordenar
        const exemptWeeks = normalizeWeeks(expanded);

        return {
            vacations: [],
            exemptWeeks,
            holidays: []
        };
    };

    const refreshPaymentHistory = async (studentId, studentIndex) => {
        try {
            const studentPaymentInfoResponse = await GetAllPaymentInfoByStudent(studentId);
            if (studentPaymentInfoResponse.status === 200) {
                const history = await paymentHistoryFormat(studentPaymentInfoResponse.response.receipt);
                setStudents(prev => {
                    const updated = [...prev];
                    updated[studentIndex] = {
                        ...updated[studentIndex],
                        paymentHistory: history,
                        schoolarship: studentPaymentInfoResponse.response.scholarship,
                        inactive_weeks: studentPaymentInfoResponse.response.inactive_weeks,
                        paused_weeks: studentPaymentInfoResponse.response.paused_weeks,
                    };
                    return updated;
                });

            } else {
                setStudents(prev => {
                    const updated = [...prev];
                    updated[studentIndex] = {
                        ...updated[studentIndex],
                        paymentHistory: []
                    };
                    return updated;
                });
            }
        } catch (err) {
            console.error("Error refrescando payment history:", err);
        }
    };

    useEffect(() => {
        if (studentPaymentHistory.length !== 0) {
            let thereIsInscription = false;
            studentPaymentHistory.some((v) => {
                const conceptsReceipt = v.payment_detail.concepts;

                thereIsInscription = conceptsReceipt.some((cr) => {
                    return parseInt(cr.id) === 4 && cr.concept_st === "PAID" && student.have_to_pay_enroll === 0; // Si se encuentra el concepto de inscripción
                });
                return thereIsInscription; // Detenemos el ciclo si se encuentra
            });

            if (student.inscription_date) {

                const ogInscription = formatToLocalDate(student.inscription_date);
                setInscriptionDate(ogInscription); // Guardamos la fecha formateada
            } else {
                const currentMonday = formatToLocalDate(getCurrentMondayISO());
                setInscriptionDate(currentMonday);
            }
            setButtonState(prev => ({
                ...prev,
                disabled_inscription: thereIsInscription
            }));
        } else {
            const ogInscription = formatToLocalDate(student.inscription_date);
            setInscriptionDate(ogInscription); // Guardamos la fecha formateada
            setButtonState(prev => ({
                ...prev,
                disabled_inscription: false
            }));
        }
    }, [studentPaymentHistory]);

    const paymentHistoryFormat = async (response) => {
        let paymentHistory = [];
        setStudentPaymentHistory(response);
        // Iteramos sobre cada pago en la respuesta
        await response.forEach(v => {
            let concepts = v.payment_detail.concepts.map(concept => concept.name);
            let amounts = v.payment_detail.concepts.map(concept => parseFloat(concept.amount));
            let combinedConcepts = {};
            let conceptWeeks = {}; // Para almacenar las semanas por concepto
            let conceptStatus = {}; // Para almacenar las semanas por concepto
            concepts.forEach((concept, index) => {
                if (combinedConcepts[concept]) {
                    combinedConcepts[concept] += amounts[index];
                    conceptWeeks[concept].push(v.payment_detail.concepts[index].week);
                    conceptStatus[concept] = v.payment_detail.concepts[index].concept_st;
                } else {
                    combinedConcepts[concept] = amounts[index];
                    conceptWeeks[concept] = [v.payment_detail.concepts[index].week];
                    conceptStatus[concept] = v.payment_detail.concepts[index].concept_st;

                }
            });
            // Creamos una lista de conceptos combinados y sus montos sumados
            let newConcept = Object.keys(combinedConcepts).join(", ");
            let newAmount = Object.values(combinedConcepts).join(", ");

            // Calculamos el porcentaje pagado por concepto
            let conceptPercentages = {};
            Object.keys(conceptWeeks).forEach(concept => {
                const weeks = conceptWeeks[concept];
                const totalPercentPaid = weeks.reduce((total, week) => {
                    const weekData = v.payment_detail.concepts.find(c => c.week === week);
                    return total + (weekData ? parseFloat(weekData.week.percent_paid) : 0);
                }, 0);
                const avgPercentPaid = weeks.length > 0 ? totalPercentPaid / weeks.length : 0;

                // Si el porcentaje es NaN o no se puede calcular, asignamos "No Aplica"
                conceptPercentages[concept] = isNaN(avgPercentPaid) ? "No Aplica" : `${avgPercentPaid.toFixed(2)}%`;
            });

            let object = {
                receipt_id: v.id,
                students: v.students || [],
                is_shared: v.is_shared,
                receipt_date: v.date_time,
                concept: newConcept,
                concept_st: conceptStatus,
                cash_audit_id: v.cash_audit_id,
                payedWeeks: v.payment_detail.concepts
                    .filter(concept =>
                        (concept.name === 'Abono' || concept.name === 'Colegiatura') &&
                        concept.week &&
                        concept.week.week &&
                        concept.week.year
                    )
                    .map(concept => ({
                        weekNumber: parseInt(concept.week.week),
                        year: parseInt(concept.week.year),
                        week: `${concept.week.week}-${concept.week.year}`,
                        percent_paid: concept.week.percent_paid,
                        paid_is_active: concept.week.paid_is_active
                    }))
                    .sort((a, b) => {
                        // Primero por año, luego por número de semana
                        if (a.year !== b.year) {
                            return a.year - b.year;
                        }
                        return a.weekNumber - b.weekNumber;
                    })
                    .map(({ week, percent_paid, paid_is_active }) => ({ week, percent_paid, paid_is_active })),

                amount: newAmount,
                conceptPercentages: conceptPercentages, // Almacenamos los porcentajes por concepto
                st: v.st,
                total_payed_amount: v.total_payed_amount,
                payment_method: v.payment_method,
                exchange_rates: v.exchange_rates,
                refund_status: v.refund_status,
                cancelled_at: v.cancelled_at,
                cancelled_by: v.cancelled_by,
                cancel_reason: v.cancel_reason
            };
            paymentHistory.push(object);
        });
        return paymentHistory;
    };

    function getCurrentMondayISO() {
        const today = new Date();
        const day = today.getDay(); // 0 (domingo) a 6 (sábado)
        const diff = today.getDate() - day + (day === 0 ? -6 : 1); // lunes
        const monday = new Date(today.setDate(diff));
        return formatToLocalDate(monday); // devuelve YYYY-MM-DD en zona local
    }

    // Helper function to update student properties
    const updateStudent = (index, field, value) => {
        setStudents(prevStudents => {
            return prevStudents.map((student, i) => {
                if (i === index) {
                    return {
                        ...student,
                        concepts_to_pay: {
                            ...student.concepts_to_pay,
                            [field]: Array.isArray(student.concepts_to_pay[field])
                                ? // Si es un arreglo (como books o tuition), actualizamos el arreglo
                                [...student.concepts_to_pay[field], ...value] // Para agregar elementos al arreglo
                                : // Si no es un arreglo (como inscription), reemplazamos el valor directamente
                                value
                        }
                    };
                }
                return student;
            });
        });
    };

    // Toggle inscription fee visibility
    const toggleInscription = () => {
        setShowInscription(prev => !prev);
    };

    useEffect(() => {
        if (showInscription) {
            const hasValidScholarship = scholarShip && scholarShip.enrollment !== null;

            const discount = hasValidScholarship
                ? amountInscription * (scholarShip.enrollment / 100)
                : 0;

            const discountedAmount = amountInscription - discount;

            handleInscriptionChange(`$ ${discountedAmount}`);
        } else {
            setInscriptionValue('');
            updateStudent(index, 'inscription', {});
        }
    }, [showInscription]);


    useEffect(() => {
        if (!student?.promotions || student.promotions.length === 0) {
            return;
        }

        let applied = false;

        student.promotions.forEach((promo) => {
            if (appliedPromoIdsRef.current.has(promo.id)) {
                return;
            }

            if (promo.payment_concept === 'Inscripcion') {
                if (buttonsState.disabled_inscription) {
                    showAlert(
                        'info',
                        `No se puede aplicar el descuento ya que el alumno ${student.name} ya pagó inscripción`
                    );
                    return;
                }
                handleInscriptionPromotions(promo);
                appliedPromoIdsRef.current.add(promo.class_promotion_id);
                applied = true;
            }

            if (promo.payment_concept === 'Colegiatura') {
                handleCollegePromotions(promo);
                appliedPromoIdsRef.current.add(promo.class_promotion_id);
                applied = true;
            }
        });

        if (applied) {
            showAlert('success', `Promoción aplicada correctamente a ${student.name}`);
        }
    }, [student.promotions]);


    const handleInscriptionPromotions = async (promo) => {
        switch (promo.type) {
            case 'free':
                handleInscriptionChange(`$ 0`)
                break;
            case '2x1':
                const promoIndex = promo.index;
                if (promoIndex % 2 === 0) {
                    // Index par => se le aplica inscripción gratis
                    handleInscriptionChange(`$ 0`);
                } else {
                    handleInscriptionChange(`$ ${amountInscription}`);
                }
                break;
            case 'percentage':
                const discount = amountInscription * (parseFloat(promo.value) / 100)
                const discountedInscription = amountInscription - discount
                handleInscriptionChange(`$ ${discountedInscription}`)
                break;
            case 'qty':
                // buscamos si la promo ya aplicó y tiene conceptos actualizados
                const updatedAmount = promo.updatedConcepts?.inscription?.amount
                    ?? student?.concepts_to_pay?.inscription?.amount
                    ?? amountInscription;

                handleInscriptionChange(`$ ${updatedAmount}`);
                break;
            default:
                break;
        }
    }
    const handleCollegePromotions = async (promo) => {
        switch (promo.type) {
            case 'free':
                setStudents(prev => prev.map((s, i) =>
                    i === index ? {
                        ...s,
                        concepts_to_pay: {
                            ...s.concepts_to_pay,
                            tuition: s.concepts_to_pay.tuition.map((b) =>
                                b.isTuition
                                    ? {
                                        ...b,
                                        amount: 0,
                                        date: b.date.map(d => ({
                                            ...d,
                                            tuition_payed: 0
                                        }))
                                    }
                                    : b
                            )
                        }
                    } : s
                ));
                break;
            case '2x1':
                showAlert('danger', 'NO HAY 2X1 EN COLEGIATURAS')
                break;
            case 'percentage':
                setStudents(prev => prev.map((s, i) =>
                    i === index ? {
                        ...s,
                        concepts_to_pay: {
                            ...s.concepts_to_pay,
                            tuition: s.concepts_to_pay.tuition.map((b) =>
                                b.isTuition
                                    ? {
                                        ...b,
                                        amount: parseFloat((b.amount * (1 - parseFloat(promo.value) / 100)).toFixed(2)),
                                        date: b.date.map(d => ({
                                            ...d,
                                            tuition_payed: parseFloat((d.tuition_payed * (1 - parseFloat(promo.value) / 100)).toFixed(2))
                                        }))
                                    }
                                    : b
                            )
                        }
                    } : s
                ));
                break;
            default:
                break;
        }
    }

    // Add a new payment
    const addPayment = () => {
        if (student.concepts_to_pay.tuition.length < 5) {
            let today = getLocalDateObject();
            let days = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
            let day = today.getDay();
            day = day === 0 ? 7 : day; // Convertimos domingo (0) en 7
            let dayName = days[day - 1]; // Restamos 1 porque el array empieza en 0

            // Determinar el monto según el día de la semana
            let tuitionAmount = 0;
            if (dayName === "Lunes" || dayName === "Martes" || dayName === "Miércoles") {
                tuitionAmount = paymentPlan.prompt; // Monto con descuento
            } else {
                tuitionAmount = paymentPlan.normal; // Monto normal
            }
            updateStudent(index, 'tuition', [{ isTuition: false, amount: 0, date: [], tuition_price: tuitionAmount }]);
        }
    };

    // Remove a payment by index
    const removePayment = (paymentIndex) => {
        setStudents(prev => prev.map((s, i) =>
            i === index ? {
                ...s,
                concepts_to_pay: {
                    ...s.concepts_to_pay,
                    tuition: s.concepts_to_pay.tuition.filter((_, j) => j !== paymentIndex)
                }
            } : s
        ));
    };

    // Add tuition if it does not already exist
    const addTuition = () => {
        let tuitionAmount = 0;
        updateStudent(index, 'tuition', [{ isTuition: true, amount: tuitionAmount, date: [], tuition_price: tuitionAmount }]);
        setStudentPay(tuitionAmount)
    };
    // Add a new book
    const addBook = () => {
        updateStudent(index, 'books', [{ id: '', name: '', amount: 0 }]);
    };

    // Remove a book by index
    const removeBook = (bookIndex) => {
        setStudents(prev => prev.map((s, i) =>
            i === index ? {
                ...s,
                concepts_to_pay: {
                    ...s.concepts_to_pay,
                    books: s.concepts_to_pay.books.filter((_, j) => j !== bookIndex)
                }
            } : s
        ));
    };
    // Handle changes in payment amount
    const handlePaymentAmountChange = (paymentIndex, value) => {
        const numericValue = value.replace(/[^0-9.]/g, ''); // Solo números y punto decimal
        const parsedValue = parseFloat(numericValue);

        setStudents(prev => {
            const updated = prev.map((s, i) =>
                i === index
                    ? {
                        ...s,
                        concepts_to_pay: {
                            ...s.concepts_to_pay,
                            tuition: s.concepts_to_pay.tuition.map((b, j) =>
                                j === paymentIndex
                                    ? { ...b, amount: isNaN(parsedValue) ? "" : parsedValue }
                                    : b
                            )
                        }
                    }
                    : s
            );

            // Aquí ya puedes hacer el console.log
            // console.log('concepts_to_pay:', updated[index].concepts_to_pay);
            return updated;
        });
    };


    function getWeekNumber(date) {
        let d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        // Ajustar para que la semana inicie en lunes
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));

        // Calcular el inicio del año
        let startOfYear = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));

        // Calcular la diferencia en días y obtener la semana
        let weekNumber = Math.ceil((((d - startOfYear) / 86400000) + 1) / 7);

        return { week: weekNumber, year: d.getUTCFullYear() };
    }

    const normalizeOldShape = (ranges) =>
        ranges.map(r => ({
            start: r.range_week_number.start,
            end: r.range_week_number.end
        }));
    // Handle changes in payment date
    const handlePaymentDateChange = (paymentIndex, date, tuitionAmount) => {
        if (date.length !== 0) {
            let today = new Date();
            let result = getWeekNumber(today);
            let tuiAmount = tuitionAmount;
            const exemptWeekSet = new Set( ////Falta setear a 0 las inactivas
                exemptWeeks.map(w => `${w.week}-${w.year}`)
            );
            const inactiveWeeksSet = student.inactive_weeks || []
            const inactiveWeeks = normalizeOldShape(inactiveWeeksSet);
            const pausedWeeksSet = student.paused_weeks || []
            const pausedWeeks = normalizeOldShape(pausedWeeksSet);
            // Array de días de clase seguro
            const classDaysArr = (student.class_days || "")
                .split(",")
                .map(d => d.trim())
                .filter(Boolean);

            // Días de la semana en español
            const days = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
            let dayIndex = today.getDay(); // 0=Domingo, 6=Sabado
            dayIndex = dayIndex === 0 ? 7 : dayIndex; // convertimos domingo=7
            let todayName = days[dayIndex - 1];

            // Caso especial: clases solo Jueves
            const isThrusdayOnly =
                student.class_type === 1 &&
                classDaysArr.length === 1 &&
                classDaysArr[0] === "Jueves";
            // Caso especial: clases solo Viernes
            const isFridayOnly =
                student.class_type === 1 &&
                classDaysArr.length === 1 &&
                classDaysArr[0] === "Viernes";
            // Caso especial: clases solo sábado
            const isSaturdayOnly =
                student.class_type === 1 &&
                classDaysArr.length === 1 &&
                classDaysArr[0] === "Sábado";

            // Caso especial: clases solo domingo
            const isSundayOnly =
                student.class_type === 1 &&
                classDaysArr.length === 1 &&
                classDaysArr[0] === "Domingo";

            // Caso especial: sábado y domingo juntos
            const isWeekendClass =
                student.class_type === 1 &&
                classDaysArr.length > 0 &&
                classDaysArr.every(d => ["Sábado", "Domingo"].includes(d));

            if (tuiAmount === 0 && !isWeekendClass) {
                // ===> Lógica normal que ya tenías
                if (todayName === "Lunes" || todayName === "Martes" || todayName === "Miércoles") {
                    tuiAmount = paymentPlan.prompt;
                } else {
                    tuiAmount = paymentPlan.normal;
                }
            }

            // === DESCUENTO DINÁMICO (IGNORA EXEMPTAS) ===
            function calculatePromptDiscount(weeksSelected, currentWeek) {
                // 1️⃣ Nos quedamos SOLO con semanas válidas:
                // - no exemptas
                // - prompt
                // - actuales o futuras
                const validWeeks = weeksSelected
                    .filter(w => {
                        if (w.isExempt) return false;

                        const diff =
                            (w.year - currentWeek.year) * 52 +
                            (w.week - currentWeek.week);

                        return diff >= 0 && w.tuition_payed === paymentPlan.prompt;
                    })
                    .sort(
                        (a, b) =>
                            (a.year - b.year) * 52 +
                            (a.week - b.week)
                    );

                if (validWeeks.length < 4) return 0;

                // 2️⃣ Cada bloque de 4 semanas prompt = $100
                const blocks = Math.floor(validWeeks.length / 4);

                return blocks * 100;
            }

            setStudents(prev =>
                prev.map((s, i) =>
                    i === index
                        ? {
                            ...s,
                            concepts_to_pay: {
                                ...s.concepts_to_pay,
                                tuition: s.concepts_to_pay.tuition.map((b, j) => {
                                    if (j === paymentIndex) {
                                        const newDateArray = date.map(d => {
                                            const weekKey = `${d.week}-${d.year}`;

                                            if (exemptWeekSet.has(weekKey) || isWeekInRanges(weekKey, inactiveWeeks) || isWeekInRanges(weekKey, pausedWeeks)) {

                                                return {
                                                    ...d,
                                                    tuition_payed: 0,
                                                    isExempt: true, // opcional, pero MUY útil
                                                };
                                            }

                                            let diff =
                                                (d.year - result.year) * 52 +
                                                (d.week - result.week);

                                            // ===> Clases solo Jueves
                                            if (isThrusdayOnly) {
                                                return {
                                                    ...d,
                                                    tuition_payed:
                                                        diff < 0
                                                            ? paymentPlan.late
                                                            : diff > 0
                                                                ? paymentPlan.prompt
                                                                : todayName === "Viernes" || todayName === "Sábado" || todayName === "Domingo"
                                                                    ? paymentPlan.normal
                                                                    : paymentPlan.prompt,
                                                };
                                            }

                                            // ===> Clases solo Viernes
                                            if (isFridayOnly) {
                                                return {
                                                    ...d,
                                                    tuition_payed:
                                                        diff < 0
                                                            ? paymentPlan.late
                                                            : diff > 0
                                                                ? paymentPlan.prompt
                                                                : todayName === "Sábado" || todayName === "Domingo"
                                                                    ? paymentPlan.normal
                                                                    : paymentPlan.prompt,
                                                };
                                            }
                                            // ===> Clases solo Sábado
                                            if (isSaturdayOnly) {
                                                return {
                                                    ...d,
                                                    tuition_payed:
                                                        diff < 0
                                                            ? paymentPlan.late
                                                            : diff > 0
                                                                ? paymentPlan.prompt
                                                                : todayName === "Domingo"
                                                                    ? paymentPlan.normal
                                                                    : paymentPlan.prompt,
                                                };
                                            }

                                            // ===> Clases solo domingo
                                            if (isSundayOnly) {
                                                return {
                                                    ...d,
                                                    tuition_payed:
                                                        diff < 0
                                                            ? paymentPlan.late
                                                            : paymentPlan.prompt,
                                                };
                                            }

                                            // ===> Clases sábado + domingo
                                            if (isWeekendClass) {
                                                return {
                                                    ...d,
                                                    tuition_payed:
                                                        diff < 0
                                                            ? paymentPlan.late
                                                            : paymentPlan.prompt,
                                                };
                                            }

                                            // ===> Lógica normal que ya tenías
                                            return {
                                                ...d,
                                                tuition_payed:
                                                    diff < 0
                                                        ? paymentPlan.late
                                                        : diff > 0
                                                            ? paymentPlan.prompt
                                                            : tuiAmount,
                                            };
                                        });

                                        if (!b.isTuition) {
                                            return {
                                                ...b,
                                                amount: 0,
                                                date: newDateArray,
                                            };
                                        }

                                        const newAmount = newDateArray.reduce(
                                            (acc, item) => acc + item.tuition_payed,
                                            0
                                        );
                                        // 🔥 DESCUENTO SOLO SI EXISTE
                                        const dynamicDiscount =
                                            paymentPlan.exist_discount === 1
                                                ? calculatePromptDiscount(
                                                    newDateArray,
                                                    result
                                                )
                                                : 0;

                                        const finalAmount = newAmount - dynamicDiscount;

                                        return {
                                            ...b,
                                            date: newDateArray,
                                            amount: finalAmount,
                                        };
                                    }
                                    return b;
                                }),
                            },
                        }
                        : s
                )
            );
        }
    };


    function getStartDateOfWeek(week, year) {
        const first = new Date(year, 0, 1);
        const day = first.getDay() || 7; // domingo = 7
        const firstMonday = new Date(first);
        firstMonday.setDate(first.getDate() - day + 1); // primer lunes del año

        const monday = new Date(firstMonday);
        monday.setDate(firstMonday.getDate() + (week - 1) * 7);
        monday.setHours(0, 0, 0, 0);

        return monday;
    }

    const handlePaymentDateChangeOnline = (paymentIndex, date, tuitionAmount) => {
        if (date.length === 0) return;

        const today = new Date();

        // 🔹 Set de semanas exemptas
        const exemptWeekSet = new Set(
            exemptWeeks.map(w => `${w.week}-${w.year}`)
        );
        const inactiveWeeksSet = student.inactive_weeks || []
        const inactiveWeeks = normalizeOldShape(inactiveWeeksSet);
        const pausedWeeksSet = student.paused_weeks || []
        const pausedWeeks = normalizeOldShape(pausedWeeksSet);


        // Dias de clase del alumno
        const classDaysArr = (student.class_days || "")
            .split(",")
            .map(d => d.trim())
            .filter(Boolean);

        // Semana actual
        const result = getWeekNumber(today);

        const includesCurrentWeek = date.some(
            d => d.year === result.year && d.week === result.week
        );

        // === DESCUENTO DINÁMICO (IGNORA EXEMPTAS) ===
        function calculatePromptDiscount(weeksSelected, currentWeek) {
            // 1️⃣ Nos quedamos SOLO con semanas válidas:
            // - no exemptas
            // - prompt
            // - actuales o futuras
            const validWeeks = weeksSelected
                .filter(w => {
                    if (w.isExempt) return false;

                    const diff =
                        (w.year - currentWeek.year) * 52 +
                        (w.week - currentWeek.week);

                    return diff >= 0 && w.tuition_payed === paymentPlan.prompt;
                })
                .sort(
                    (a, b) =>
                        (a.year - b.year) * 52 +
                        (a.week - b.week)
                );

            if (validWeeks.length < 4) return 0;

            // 2️⃣ Cada bloque de 4 semanas prompt = $100
            const blocks = Math.floor(validWeeks.length / 4);

            return blocks * 100;
        }


        // === ACTUALIZAR ESTADO ===
        setStudents(prev =>
            prev.map((s, i) =>
                i === index
                    ? {
                        ...s,
                        concepts_to_pay: {
                            ...s.concepts_to_pay,
                            tuition: s.concepts_to_pay.tuition.map((b, j) => {
                                if (j !== paymentIndex) return b;

                                const newDateArray = date.map(d => {
                                    const weekKey = `${d.week}-${d.year}`;

                                    // 🚫 SEMANA EXEMPTA
                                    if (exemptWeekSet.has(weekKey) || isWeekInRanges(weekKey, inactiveWeeks) || isWeekInRanges(weekKey, pausedWeeks)) {
                                        return {
                                            ...d,
                                            tuition_payed: 0,
                                            isExempt: true,
                                        };
                                    }

                                    const diff =
                                        (d.year - result.year) * 52 +
                                        (d.week - result.week);

                                    // 🔹 PROMO ONLINE 4 SEMANAS
                                    if (date.length === 4 && includesCurrentWeek) {
                                        if (diff < 0) {
                                            return {
                                                ...d,
                                                tuition_payed: paymentPlan.late,
                                            };
                                        }

                                        return {
                                            ...d,
                                            tuition_payed: paymentPlan.prompt,
                                        };
                                    }

                                    // 🔹 PRONTO PAGO SEGÚN DÍA REAL
                                    const monday = getStartDateOfWeek(d.week, d.year);
                                    const daysOrder = [
                                        "Lunes",
                                        "Martes",
                                        "Miércoles",
                                        "Jueves",
                                        "Viernes",
                                        "Sábado",
                                        "Domingo",
                                    ];

                                    const classDayIndex =
                                        classDaysArr.length > 0
                                            ? Math.min(
                                                ...classDaysArr.map(
                                                    day => daysOrder.indexOf(day) + 1
                                                )
                                            )
                                            : 1;

                                    const classDate = new Date(monday);
                                    classDate.setDate(
                                        monday.getDate() + (classDayIndex - 1)
                                    );

                                    const promptDeadline = new Date(classDate);
                                    promptDeadline.setDate(
                                        classDate.getDate() + 10
                                    );

                                    const stillPrompt = today <= promptDeadline;

                                    if (stillPrompt) {
                                        return {
                                            ...d,
                                            tuition_payed: paymentPlan.prompt,
                                        };
                                    }

                                    if (diff > 0) {
                                        return {
                                            ...d,
                                            tuition_payed: paymentPlan.prompt,
                                        };
                                    }

                                    return {
                                        ...d,
                                        tuition_payed: paymentPlan.late,
                                    };
                                });

                                // 🔹 SUMA BASE (EXEMPTAS YA VALEN 0)
                                const newAmount = newDateArray.reduce(
                                    (acc, item) => acc + item.tuition_payed,
                                    0
                                );

                                // 🔥 DESCUENTO SOLO SI EXISTE
                                const dynamicDiscount =
                                    paymentPlan.exist_discount === 1
                                        ? calculatePromptDiscount(
                                            newDateArray,
                                            result
                                        )
                                        : 0;

                                const finalAmount = newAmount - dynamicDiscount;

                                return {
                                    ...b,
                                    date: newDateArray,
                                    amount: finalAmount,
                                };
                            }),
                        },
                    }
                    : s
            )
        );
    };

    const handleInscriptionChange = (value) => {
        // Elimina cualquier carácter no numérico (excepto el punto decimal)
        const numericValue = value.replace(/[^0-9.]/g, '');

        // Si el input está vacío, restablece el estado y actualiza el estudiante
        if (numericValue === '') {
            setInscriptionValue('');
            updateStudent(index, 'inscription', {}); // O el valor adecuado en tu lógica
            return;
        }

        // Convierte el valor en número flotante
        const parsedValue = parseFloat(numericValue);

        // Si el valor es NaN, no actualiza
        if (!isNaN(parsedValue)) {
            setInscriptionValue(numericValue);
            updateStudent(index, 'inscription', { amount: parsedValue });
        }
    };

    // Handle book selection change
    const handleBookSelectChange = (bookIndex, selectedValue) => {
        setStudents(prev => prev.map((s, i) =>
            i === index ? {
                ...s,
                concepts_to_pay: {
                    ...s.concepts_to_pay,
                    books: s.concepts_to_pay.books.map((b, j) =>
                        j === bookIndex
                            ? (() => {
                                const selectedBook = books.find(book => book.value === selectedValue);
                                return {
                                    id: selectedBook.value,
                                    name: selectedBook.label,
                                    price: selectedBook.price
                                };
                            })()
                            : b
                    )
                }
            } : s
        ));
    };
    // Función para construir el nombre completo
    const getFullName = (alumno) => {
        return `${alumno.name}`;
    };


    const ConfirmActionPassword = async () => {
        const checkPasswordConfirm = await handleConfirmActionPassword();
        const { status, message } = checkPasswordConfirm;
        if (status) {
            setDisabledTuition(false)
            return showAlert('success', message);
        }


    };
    const ConfirmActionPasswordInscription = async () => {
        const checkPasswordConfirm = await handleConfirmActionPassword();
        const { status, message } = checkPasswordConfirm;
        if (status) {
            setDisabledInscriptionInput(false)
            return showAlert('success', message);
        }


    };

    const handleConfirmActionPassword = () => {
        return new Promise((resolve) => {
            setIsPasswordRequired(true); // Abre el modal

            // Pasas estas funciones al modal para controlar los botones
            const handleAcceptPassword = (formValues) => {
                if (formValues.employee_id !== '' && formValues.password !== '') {
                    const responseToConfirmation = PostReceptionistInCharge(formValues)
                    responseToConfirmation.then((value) => {
                        let status = value.status
                        if (value.hasOwnProperty("auth")) {
                            status = 202
                        }
                        switch (status) {
                            case 200:
                                setIsPasswordRequired(false); // Cierra el modal
                                resolve({ status: true, message: "Edicion Permitida" }); // Resuelve la promesa con "true" si acepta
                                break;
                            case 201:
                                showAlert('info', "Credenciales rechazadas para realizar la edición")

                                break;
                            case 202:
                                showAlert('info', "Credenciales expiradas")
                                break;
                            default:
                                showAlert('danger', 'Error de conexión, recargue la pagina.');
                                break;
                        }

                    })
                } else {
                    showAlert('danger', 'Ingrese el correo y la contraseña para verificar sus credenciales.')
                }
            };

            const handleCancelPassword = () => {
                setIsPasswordRequired(false); // Cierra el modal
                resolve(false); // Resuelve la promesa con "false" si cancela
            };

            // Almacenar funciones en el estado para pasar al modal
            setModalHandlers({ handleAcceptPassword, handleCancelPassword });
        });
    }

    const handleSchoolarship = (paymentIndex) => {
        setStudents(prev => prev.map((s, i) =>
            i === index ? {
                ...s,
                concepts_to_pay: {
                    ...s.concepts_to_pay,
                    tuition: s.concepts_to_pay.tuition.map((b, j) => {
                        if (j === paymentIndex) {
                            const scholarship = s.schoolarship;
                            const hasValidScholarship = scholarship && scholarship.normal !== null;

                            const updatedDates = b.date.map(week => {
                                const original = week.tuition_payed;
                                const discount = hasValidScholarship
                                    ? original * (scholarship.normal / 100)
                                    : 0;
                                return {
                                    ...week,
                                    tuition_payed: original - discount,
                                };
                            });
                            const total = updatedDates.reduce((acc, w) => acc + w.tuition_payed, 0);
                            return {
                                ...b,
                                date: updatedDates,
                                amount: total,
                            };
                        }
                        return b;
                    })
                }
            } : s
        ));
    };
    const [disableObservationButton, setDisableObservationButton] = useState(false)
    const handleSaveObservation = async () => {
        setDisableObservationButton(true)
        const updateObservation = await PatchUpdateObservationByStudent(studentId, observation)
        if (updateObservation.status === 200) {
            showAlert('success', updateObservation.message);
            setTimeout(() => {
                setDisableObservationButton(false)
            }, 2000);
        } else {
            showAlert('danger', updateObservation.message);
            setDisableObservationButton(false)
        }
    }

    const handleClosePrintReceipt = () => {
        setIsOpenPrintReceipt(false);
    }
    const openConfirm = (title, message, actionPayload) => {
        setConfirmConfig({ title, message });
        setPendingAction(actionPayload); // 👈 datos, NO funciones
        setIsOpenConfirmRefundCancelReceipt(true);
    };

    const handleAcceptConfirm = async () => {
        setIsOpenConfirmRefundCancelReceipt(false);
        if (!pendingAction) return;

        // 👇 aquí decides qué hacer
        if (pendingAction.type === 'CANCEL_RECEIPT') {
            handleCancelReceipt(pendingAction)
        }
        if (pendingAction.type === 'CHANGE_PAYMENT_METHOD_RECEIPT') {
            handleChangePaymentMethodReceipt(pendingAction.receipt)
        }
        if (pendingAction.type === 'REFUND_RECEIPT') {
            const actionPassword = await handleConfirmActionPassword()
            if (actionPassword.status === true) {
                handleReceiptToRefund(pendingAction.receipt_id)
            }
        }

        setPendingAction(null);
    };

    const handleReceiptToRefund = async (receipt_id) => {
        const getReceipt_to_Refund = await GetInfoReceiptToRefund(receipt_id)
        if (getReceipt_to_Refund.status === 200) {
            setIsRefundModalOpen(true);
            setReceiptDataToRefund(getReceipt_to_Refund.result)
        }

    }

    const handleCloseRefundReceipt = () => {
        setIsRefundModalOpen(false);
    }

    const handleChangePaymentMethodReceipt = async (receipt) => {
        setDataChangePaymentMethod(receipt)
        setIsOpenChangePaymentMethodModal(true)
    }
    const handleCloseChangePaymentMethodModal = async () => {
        setIsOpenChangePaymentMethodModal(false)
    }
    const handleCancelReceipt = async (response) => {
        if (!response) return showAlert('danger', 'no se encontro el recivo')
        if (!usr) return showAlert('danger', 'no se encontro el numero de empleado')
        const cancellingReceipt = await PatchCancelReceipt(response.receiptId, usr.employee_id, 'reason', studentId)
        if (cancellingReceipt.status === 200) {
            const amount_cancelled = dataDecrypt(localStorage.getItem('alarmToCashAudit'))
            const newAmountForAlarm = amount_cancelled - cancellingReceipt.amount_cancelled_effective
            localStorage.setItem(
                'alarmToCashAudit',
                dataEncrpt(newAmountForAlarm)

            );
            showAlert('success', cancellingReceipt.message);
            setLoading(true)
            setTimeout(async () => {
                await refreshPaymentHistory(studentId, index);
                setLoading(false)
            }, 500);
        } else {
            showAlert('danger', cancellingReceipt.message);
            setLoading(false)
        }
    }

    useEffect(() => {
        if (refreshPaymentHistorySt === true) {
            setLoading(true)
            setTimeout(async () => {
                await refreshPaymentHistory(studentId, index);
                setLoading(false)
                setRefreshPaymentHistorySt(false)
            }, 500);
        }
    }, [refreshPaymentHistorySt])

    const handleCancelConfirm = () => {
        setIsOpenConfirmRefundCancelReceipt(false);
        setPendingAction(null);
    };
    return (
        <div className="student-section main-color">
            <div className="payment-actions">
                <Tooltip text="Eliminar alumno">
                    <Button backgroundColor="transparent" onClick={() => removeStudentSection(index)} Icon={CloseSVG} />
                </Tooltip>
            </div>
            {/* Select para elegir el alumno usando la lista extraída desde RECEIPTS */}
            <div className='autocomplete_select'>
                <InputAutoComplete
                    options={studentsList}// Pasa los objetos completos como opciones 
                    getOptionLabel={(option) => getFullName(option)} // Controla cómo se muestra el texto en las opciones
                    value={
                        studentsList.find(s => s.id === student.id_student) || null
                    } // Aquí pasas el objeto completo
                    onChange={(event, newValue) => handleStudentChange(newValue)}
                    isOptionEqualToValue={(option, value) => option.id === value.id} // Comparación basada en el 'id'
                    className={'search-box main-color'}
                    placeholder={"Buscar Alumno..."}
                />

            </div>
            <div className='student-section-content'>

                <div className="payment-concepts">
                    {student.concepts_to_pay?.tuition.map((payment, paymentIndex) => (
                        <div key={paymentIndex} className="tuition-data" >
                            <div className="payment-actions">
                                <Tooltip
                                    text={payment.isTuition ? "Eliminar colegiatura" : "Eliminar abono"}
                                >
                                    <Button backgroundColor="transparent"
                                        onClick={() => removePayment(paymentIndex)}
                                        Icon={CloseSVG}
                                    />
                                </Tooltip>
                            </div>
                            <div className='tuition-inputs'>
                                <InputDate
                                    selectionType={payment.isTuition ? "week-range" : "week"}
                                    valueType="weekNumber"
                                    value={payment.date}
                                    onChange={(date) =>
                                        payment.isTuition &&
                                            paymentPIsOnline
                                            ? handlePaymentDateChangeOnline(paymentIndex, date, studentPay)
                                            : handlePaymentDateChange(paymentIndex, date, studentPay)
                                    }
                                    minDate={inscriptionDate}
                                    placeholder={"Seleccione semana(s) a pagar"}
                                    onClose={() => { (scholarShip && scholarShip.enrollment !== null) && handleSchoolarship(paymentIndex) }}
                                    specialDates={specialDates}
                                />
                                <div className='tuition-amount-qty'>
                                    <Tooltip text={'Selecciona semana a pagar para calcular costo (Colegiatura).'}>

                                        <InputAnimated
                                            type="text"
                                            placeholder={payment.isTuition ? "Colegiatura" : "Abono"}
                                            disabled={payment.isTuition ? disableTuition : false}
                                            className="tuition-amount"
                                            value={`$  ${payment.amount}`}
                                            onChange={(e) => handlePaymentAmountChange(paymentIndex, e.target.value)}
                                        />
                                    </Tooltip>
                                    <Tooltip text={'Editar cantidad a pagar manualmente (Requiere autorización).'}>
                                        <Button Icon={EditSVG} onClick={ConfirmActionPassword}></Button>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    ))}
                    {showInscription && (
                        <div className="concept-item payment-actions inscription">
                            <Tooltip text="Eliminar inscripción">
                                <Button backgroundColor="transparent"
                                    onClick={toggleInscription}
                                    Icon={CloseSVG} />
                            </Tooltip>
                            <InputAnimated
                                type="text"
                                placeholder="Inscripción"
                                value={`$ ${inscriptionValue}`} // Muestra el valor con el símbolo "$"
                                onChange={(e) => handleInscriptionChange(e.target.value)}
                                disabled={disableInscriptionInput}

                            />
                            <Button Icon={EditSVG} onClick={ConfirmActionPasswordInscription}></Button>

                        </div>
                    )}

                    {student.concepts_to_pay?.books && student.concepts_to_pay.books?.map((bookValue, bookIndex) => {
                        return (
                            <div className="concept-item payment-actions" key={bookIndex}>
                                <Tooltip text="Eliminar libro">
                                    <Button backgroundColor="transparent"
                                        onClick={() => removeBook(bookIndex)}
                                        Icon={CloseSVG} />
                                </Tooltip>
                                <div className='concept-inputs'>
                                    <Select
                                        options={books}
                                        classN="main-color"
                                        placeholder="Selecciona un libro"
                                        value={bookValue?.id || ""}
                                        onChange={(selectedBook) => handleBookSelectChange(bookIndex, selectedBook.target.value)}
                                    />

                                    <InputAnimated
                                        type="text"
                                        placeholder="Precio de Libro"
                                        value={bookValue?.id ? `$  ${bookValue?.price}` : ''}
                                        readOnly
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Payment history section */}
                <div className="payment-history">
                    {student.paymentHistory && student.paymentHistory.length > 0 ? (
                        <div className='paymente-history-content'>
                            <div className='student-notes'>
                                <h1 className='title-2'>Observaciones</h1>
                                <textarea
                                    value={observation}
                                    onChange={(e) => setObservation(e.target.value)}
                                />
                                <Button
                                    text='Guardar cambios'
                                    onClick={handleSaveObservation}
                                    disabled={disableObservationButton}
                                />
                            </div>

                            <div className='full_class_name'>
                                <h1 className='title-2'>Clase</h1>
                                <h3 className='emphasis-2'>{fullClassName}</h3>
                                <br />
                                {
                                    weeksRemaining !== null && weeksRemaining !== undefined &&
                                    <h3 className='emphasis-2'>
                                        {weeksRemaining === 0
                                            ? 'Ultima semana del nivel actual'
                                            : `Semanas restantes: ${weeksRemaining}`
                                        }
                                    </h3>
                                }
                            </div>

                            {paymentPlan?.id && (
                                <div className='paymente_history_payment_plan_name'>
                                    <h1 className='title-2'>Plan de pago</h1>
                                    <Tooltip text={'Solamente se esta mostrando el plan de pago y si este es online o presencial, no tiene nada que ver con la modalidad de la clase'}>
                                        <h3 className='emphasis-2'>
                                            Puntual: {paymentPlan?.prompt} / Normal: {paymentPlan?.normal} / Atrasado: {paymentPlan?.late} - {paymentPlan?.is_online === 1 ? 'Online' : 'Presencial'} / {paymentPlan?.exist_discount === 1 ? 'Con descuento' : 'Sin descuento'}
                                        </h3>
                                    </Tooltip>
                                </div>
                            )}

                            {loading ? (
                                <LoadingComponent />
                            ) : (
                                <PaymentHistory
                                    openConfirm={openConfirm}
                                    setIsOpenPrintReceipt={setIsOpenPrintReceipt}
                                    setReceiptData={setReceiptResultData}
                                    student={student}
                                    paymentPlan={paymentPlan}
                                />
                            )}
                        </div>
                    ) : !student.id_student && student.paymentHistory.length === 0 ? (
                        <div className='payment-history-txt'>
                            Selecciona un alumno para mostrar historial de pago
                        </div>
                    ) : (
                        <div className='payment-history-txt'>
                            El alumno no cuenta con ningún pago
                        </div>
                    )}
                </div>

            </div>

            <div className="student-section-buttons">
                {!showInscription &&
                    <Tooltip text={'Solo es posible agregar inscripcion cuando el alumno No ha realizado ese pago'}>
                        <Button disabled={student.id_student && !buttonsState.disabled_inscription ? false : true} text="+ Inscripción" onClick={toggleInscription}
                        />
                    </Tooltip>
                }
                <Tooltip text={'Añadir sección de libro'}>
                    <Button disabled={student.id_student ? false : true} text="+ Libro" onClick={addBook} />
                </Tooltip>
                {!student.concepts_to_pay?.tuition?.some(payment => !payment.isTuition) && (
                    <Tooltip text={'Solo se pueden abonar semanas consecutivas ó de vacaciones'} position='left'>
                        <Button disabled={student.id_student ? false : true} text="+ Abono" onClick={addPayment} />
                    </Tooltip>

                )}
                {!student.concepts_to_pay?.tuition?.some(payment => payment.isTuition) && (
                    <Tooltip text={'Añadir semanas de colegiatura a pagar'}>
                        <Button disabled={student.id_student ? false : true} text="+ Colegiatura" onClick={addTuition} />
                    </Tooltip>
                )}
            </div>
            {isPasswordRequired && <PasswordAlert handleAccept={modalHandlers.handleAcceptPassword} isOpen={isPasswordRequired} handleCancel={modalHandlers.handleCancelPassword}
                text={'Ingrese las credenciales'}
                title={'Se necesita autorizacion'}
            />}
            {isOpenPrintReceipt && <RePrintReceipt isOpen={isOpenPrintReceipt} onClose={handleClosePrintReceipt} receiptData={receiptResultData} />}
            <ConfirmModal
                isOpen={isOpenConfirmRefundCancelReceipt}
                title={confirmConfig.title}
                text={confirmConfig.message}
                handleAccept={handleAcceptConfirm}
                handleCancel={handleCancelConfirm}
            />
            <ChangeReceiptPaymentMethod setRefreshPaymentHistorySt={setRefreshPaymentHistorySt} showAlert={showAlert} exchange={exchange} isOpen={isOpenChangePaymentMethodModal} onClose={handleCloseChangePaymentMethodModal} data={dataChangePaymentMethod} />
            <PaymentRefund isOpen={isRefundModalOpen} onClose={handleCloseRefundReceipt} showAlert={showAlert} receiptData={receiptDataToRefund} employee_id={usr.employee_id} refreshPaymentHistory={refreshPaymentHistory} setLoading={setLoading} studentId={studentId} index={index} />

        </div>
    );
};

export default StudentSection;
